// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/film.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/film'

import { Icon, type IconComponentProps } from '../icon'

export const FilmIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
